import { fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    ellipseRxRatio: 0.5,
    ellipseRyRatio: 0.2
};
/**
 * A visual element that renders a database symbol with cylindrical appearance.
 * Extends Rectangle and provides functionality for creating database storage shapes with elliptical top and bottom.
 */
export class Database extends Rectangle {
    /**
     * Creates a new Database instance.
     * @param options Configuration options for the database shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /** @hidden */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const rx = width * this.options.ellipseRxRatio;
        const ellipseRY = height * this.options.ellipseRyRatio;
        const cy = ellipseRY;
        const ry = ellipseRY;
        drawingElement
            .moveTo([width, cy])
            .arcTo([0, cy], rx, ry, false, true)
            .arcTo([width, cy], rx, ry, false, true)
            .lineTo([width, height])
            .arcTo([0, height], rx, ry, false, true)
            .lineTo([0, cy]);
        fitToSize(this.drawingElement, width, height, strokeWidth);
    }
}
